import { BuilderType, projectsCacheTags } from "./projectsApiHelpers";

export type Note = {};

export const notesApi = (builder: BuilderType) => ({
  createNote: builder.mutation<Note, any>({
    query: (note) => ({
      url: `service/notes`,
      method: "POST",
      body: note,
    }),
    invalidatesTags: [projectsCacheTags.NOTES],
  }),

  updateNote: builder.mutation<Note, any>({
    query: (note) => ({
      url: `service/notes/${note.id}`,
      method: "PUT",
      body: note,
    }),
    invalidatesTags: [projectsCacheTags.NOTES],
  }),

  deleteNote: builder.mutation<Note, number>({
    query: (id) => ({
      url: `service/notes/${id}`,
      method: "DELETE",
    }),
    invalidatesTags: [projectsCacheTags.NOTES],
  }),
});
